import Disputes from "../../../views/Disputes";
import DisputeDetails from "../../../views/Disputes/DisputeDetails";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const DisputesRoutes = [
  {
    menuName: MenuNames.DISPUTES,
    path: "/disputes",
    component: Disputes,
    exact: true,
  },
  {
    menuName: MenuNames.DISPUTES,
    path: "/disputes/:id/:detailType?",
    component: DisputeDetails,
    exact: false,
  },
];

export default DisputesRoutes;
